import type { GoogleHealthPayload } from "../types/googleHealthBridge.types";
import { parseGoogleHealthPayload } from "./nativeHealthBridge";

/** Extract `{ health_data: [...] }` from getUserData or onHealthData bridge responses. */
export const extractHealthPayloadFromBridge = (
  raw: unknown,
): GoogleHealthPayload | null => {
  const direct = parseGoogleHealthPayload(raw);
  if (direct) return direct;

  if (!raw || typeof raw !== "object") return null;
  const obj = raw as Record<string, unknown>;

  for (const key of ["health_data", "healthData", "google_health", "googleHealth"]) {
    const nested = obj[key];
    if (Array.isArray(nested)) {
      return parseGoogleHealthPayload({ ...obj, health_data: nested });
    }
    if (nested && typeof nested === "object") {
      const parsed = parseGoogleHealthPayload(nested);
      if (parsed) return parsed;
    }
  }

  return null;
};
